import { getBoardUserMetaCardPreviewHiddenProperties } from '../../../../../../../../../store/model/board/selectors/getBoardUserMetaCardPreviewHiddenProperties';
import { EKanbanCardProperty, IApplicationState, TBoardId } from '../../../../../../../../../types/types';

export const getIsShowKnbCardAssignees = (
    state: IApplicationState,
    boardId: TBoardId
): boolean => {
    return !getBoardUserMetaCardPreviewHiddenProperties(state, boardId).includes(EKanbanCardProperty.ASSIGNEES);
};
